/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export enum Currency {
  'AED' = 'د.إ.‏',
  'AFN' = '؋',
  'ALL' = 'Lekë',
  'AMD' = '֏',
  'ANG' = 'NAf.',
  'AOA' = 'Kz',
  'ARS' = '$',
  'AUD' = '$',
  'AWG' = 'Afl.',
  'AZN' = '₼',
  'BAM' = 'КМ',
  'BBD' = '$',
  'BDT' = '৳',
  'BGN' = 'лв.',
  'BHD' = 'د.ب.‏',
  'BIF' = 'FBu',
  'BMD' = '$',
  'BND' = '$',
  'BOB' = 'Bs',
  'BOV' = 'BOV',
  'BRL' = 'R$',
  'BSD' = '$',
  'BTN' = 'Nu.',
  'BWP' = 'P',
  'BYN' = 'Br',
  'BZD' = '$',
  'CAD' = '$',
  'CDF' = 'FC',
  'CHE' = 'CHE',
  'CHF' = 'CHF',
  'CHW' = 'CHW',
  'CLF' = 'CLF',
  'CLP' = '$',
  'CNH' = 'CNH',
  'CNY' = '¥',
  'COP' = '$',
  'COU' = 'COU',
  'CRC' = '₡',
  'CUC' = 'CUC',
  'CUP' = '$',
  'CVE' = '​',
  'CZK' = 'Kč',
  'DJF' = 'Fdj',
  'DKK' = 'kr.',
  'DOP' = 'RD$',
  'DZD' = 'د.ج.‏',
  'EGP' = 'ج.م.‏',
  'ERN' = 'Nfk',
  'ETB' = 'ብር',
  'EUR' = '€',
  'FJD' = '$',
  'FKP' = '£',
  'GBP' = '£',
  'GEL' = '₾',
  'GHS' = 'GH₵',
  'GIP' = '£',
  'GMD' = 'D',
  'GNF' = 'FG',
  'GTQ' = 'Q',
  'GYD' = '$',
  'HKD' = 'HK$',
  'HNL' = 'L',
  'HRK' = 'HRK',
  'HTG' = 'G',
  'HUF' = 'Ft',
  'IDR' = 'Rp',
  'ILS' = '₪',
  'INR' = '₹',
  'IQD' = 'د.ع.‏',
  'IRR' = 'IRR',
  'ISK' = 'ISK',
  'JMD' = '$',
  'JOD' = 'د.أ.‏',
  'JPY' = '￥',
  'KES' = 'Ksh',
  'KGS' = 'сом',
  'KHR' = '៛',
  'KMF' = 'CF',
  'KPW' = 'KPW',
  'KRW' = '₩',
  'KWD' = 'د.ك.‏',
  'KYD' = '$',
  'KZT' = '₸',
  'LAK' = '₭',
  'LBP' = 'ل.ل.‏',
  'LKR' = 'රු.',
  'LRD' = '$',
  'LSL' = 'LSL',
  'LYD' = 'د.ل.‏',
  'MAD' = 'د.م.‏',
  'MDL' = 'L',
  'MGA' = 'Ar',
  'MKD' = 'ден',
  'MMK' = 'K',
  'MNT' = '₮',
  'MOP' = 'MOP$',
  'MRO' = 'أ.م.‏',
  'MUR' = 'Rs',
  'MWK' = 'MK',
  'MXN' = '$',
  'MXV' = 'MXV',
  'MYR' = 'RM',
  'MZN' = 'MTn',
  'NAD' = '$',
  'NGN' = '₦',
  'NIO' = 'C$',
  'NOK' = 'kr',
  'NPR' = 'नेरू',
  'NZD' = '$',
  'OMR' = 'ر.ع.‏',
  'PAB' = 'B/.',
  'PEN' = 'S/',
  'PGK' = 'K',
  'PHP' = '₱',
  'PKR' = 'Rs',
  'PLN' = 'zł',
  'PYG' = 'Gs.',
  'QAR' = 'ر.ق.‏',
  'RON' = 'RON',
  'RSD' = 'RSD',
  'RUB' = '₽',
  'RWF' = 'RF',
  'SAR' = 'ر.س.‏',
  'SBD' = '$',
  'SCR' = 'SR',
  'SDG' = 'ج.س.',
  'SEK' = 'kr',
  'SGD' = '$',
  'SHP' = '£',
  'SLL' = 'Le',
  'SOS' = 'S',
  'SRD' = '$',
  'SSP' = '£',
  'STN' = 'STN',
  'SYP' = 'ل.س.‏',
  'SZL' = 'E',
  'THB' = 'THB',
  'TJS' = 'сом.',
  'TND' = 'د.ت.‏',
  'TOP' = 'T$',
  'TRY' = '₺',
  'TTD' = '$',
  'TWD' = '$',
  'TZS' = 'TSh',
  'UAH' = '₴',
  'UGX' = 'USh',
  'USD' = '$',
  'USN' = 'USN',
  'UYI' = 'UYI',
  'UYU' = '$',
  'UZS' = 'сўм',
  'VEF' = 'Bs.',
  'VND' = '₫',
  'VUV' = 'VT',
  'WST' = 'WS$',
  'XAF' = 'FCFA',
  'XCD' = '$',
  'XOF' = 'CFA',
  'XPF' = 'FCFP',
  'YER' = 'ر.ي.‏',
  'ZAR' = 'R',
  'ZMW' = 'K',
}
